import { render, staticRenderFns } from "./OrderSelection.vue?vue&type=template&id=2bb62a6c&"
import script from "./OrderSelection.vue?vue&type=script&lang=js&"
export * from "./OrderSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VImg,VProgressCircular,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bb62a6c')) {
      api.createRecord('2bb62a6c', component.options)
    } else {
      api.reload('2bb62a6c', component.options)
    }
    module.hot.accept("./OrderSelection.vue?vue&type=template&id=2bb62a6c&", function () {
      api.rerender('2bb62a6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ShopSetting/Pages/Order/components/OrderSelection.vue"
export default component.exports